<template>
  <span class="p-2" v-if="iconText!=''" >
    <a :href="MediaObject.ObjectText" target="_blank">
        {{iconText}}-media
     
    </a>
</span>
</template>

<script>
export default {
    props: { MediaObject: Object},
    computed: {
    icon() {
        if(!this.MediaObject.ObjectType || this.MediaObject.ObjectType==null){
            return "";
        }
        switch (this.MediaObject.ObjectType) {
            case "BMP":
                return "bi-filetype-bmp"
                break;
            case "SND":
                return "bi-filetype-mp3"
                break;
            case "VID":
                return "bi-filetype-m4p"
                break;
            case "GIF":
                return "bi-filetype-gif"
                break;
            default:
                return "bi-filetype-" + this.MediaObject.ObjectType.toLowerCase()
                break;
        }      
    },
    iconText() {
        if(!this.MediaObject.ObjectType || this.MediaObject.ObjectType==null){
            return "";
        }
        return this.MediaObject.ObjectType.toLowerCase()
    },
    link(){
        return "";
    } 
    }
}
</script>

<style>

</style>